export default __webpack_public_path__ + "static/media/e1.857e2548.svg";